export default __webpack_public_path__ + "static/media/crioLogoDark.050e7019.jpg";